class CartItemQty extends HTMLElement {
  constructor() {
    super();
    this.quantityBtns = this.querySelectorAll("[data-quantity-btn-type]");
  }

  callUpdateQty(value) {
    let correctValue = value;
    if (value >= this.maxQty) correctValue = this.maxQty;
    if (value < 0) correctValue = 0;

    if (this.input.closest("cart-drawer")) {
      this.input
        .closest("cart-drawer")
        .updateQty(this.line.getAttribute("data-key"), parseInt(correctValue));
    } else {
      this.input
        .closest("cart-page")
        .updateQty(this.line.getAttribute("data-key"), parseInt(correctValue));
    }
  }

  btnEvents() {
    if (!this.quantityBtns || this.quantityBtns.length === 0) return;

    function getValue(type) {
      let value = this.activeQty;

      if (type == "minus") {
        value = Math.max(value - 1, 0);
      } else {
        value++;
      }

      return value;
    }

    this.quantityBtns.forEach((btn) => {
      let type = btn.getAttribute("data-quantity-btn-type");

      btn.addEventListener("click", () => {
        let inputValue = getValue.call(this, type);
        this.callUpdateQty(inputValue);
      });
    });
  }

  connectedCallback() {
    this.line = this.closest("cartline-item");
    this.input = this.querySelector("input");
    this.maxQty = parseInt(this.input.max);
    this.activeQty = parseInt(this.input.value);

    this.input.addEventListener("change", (e) => {
      this.callUpdateQty(e.target.value);
    });

    this.btnEvents();
  }
}

class CartCount extends HTMLElement {
  constructor() {
    super();
    this.itemCount = 0;
  }

  updateCount() {
    fetch(window.Shopify.routes.root + "cart.json")
      .then((response) => {
        return response.json();
      })
      .then((cartJSON) => {
        this.itemCount = cartJSON.item_count;

        if (this.itemCount == 0) {
          this.removeAttribute("data-count-active");
        } else {
          this.setAttribute("data-count-active", "");
        }

        if (this.querySelector("[data-count]")) {
          this.querySelector("[data-count]").innerText = this.itemCount;
        } else {
          this.innerText = this.itemCount;
        }
      });
  }
}

class CartItemRemove extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.line = this.closest("cartline-item");

    this.addEventListener("click", () => {
      if (this.closest("cart-drawer")) {
        this.closest("cart-drawer").removeLine(
          this.line.getAttribute("data-key")
        );
      } else {
        this.closest("cart-page").removeLine(
          this.line.getAttribute("data-key")
        );
      }
    });
  }
}

class Cart extends HTMLElement {
  constructor() {
    super();
    this.sectionsToRefresh = this.getAttribute("data-sections");
    this.cartJSON = {};
    this.domParser = new DOMParser();
  }

  renderSections() {
    this.sectionIdList = this.sectionsToRefresh.split(",");

    this.sectionsHTML = this.sectionIdList.map((sectionId) => {
      return this.domParser
        .parseFromString(this.cartJSON.sections[sectionId], "text/html")
        .getElementById(sectionId).innerHTML;
    });

    this.sectionIdList.forEach((id, index) => {
      var targ = document.getElementById(id);
      if (targ) {
        targ.innerHTML = this.sectionsHTML[index];
      }
    });
  }

  cartIsEmpty() {
    if (document.querySelector(".cart__rec")) {
      document.querySelector(".cart__rec").style.display = "none";
    }
  }

  setCartCount() {
    document.querySelectorAll("cart-count").forEach((elem) => {
      elem.updateCount();
    });
  }

  reloadPDPGiftTeaser() {
    this.pdpFreeGiftTeaserElem = document.querySelector(
      ".pdp-freegift-countdown"
    );

    if (!this.pdpFreeGiftTeaserElem) {
      return;
    }

    var pdpMainSectionId = this.pdpFreeGiftTeaserElem
      .closest(".shopify-section.template-product")
      .id.replace("shopify-section-", "");

    var reqURL = new URL(window.location.href);
    reqURL.searchParams.set("sections", pdpMainSectionId);

    fetch(reqURL)
      .then((res) => res.json())
      .then((resJSON) => {
        var domparser = new DOMParser();
        var resHTML = domparser.parseFromString(
          resJSON[pdpMainSectionId],
          "text/html"
        );
        this.pdpFreeGiftTeaserElem.innerHTML = resHTML.querySelector(
          ".pdp-freegift-countdown"
        ).innerHTML;
      });
  }

  cartUpdated() {
    this.setCartCount();

    this.reloadPDPGiftTeaser();

    if (this.cartJSON.item_count) {
      if (this.cartJSON.item_count == 0) {
        this.cartIsEmpty();
      }
    } else {
      this.cartIsEmpty();
    }
  }

  removeLine(key) {
    var reqBody = {};
    reqBody.id = key;
    reqBody.quantity = 0;
    reqBody.sections = this.sectionsToRefresh;

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqBody),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseJSON) => {
        this.cartJSON = responseJSON;
        this.cartUpdated();
        this.renderSections();
      });
  }

  updateQty(key, qty) {
    if (qty === 0) {
      this.removeLine(key);
    }

    if (qty !== 0) {
      var reqBody = {};
      reqBody.id = key;
      reqBody.quantity = qty;
      reqBody.sections = this.sectionsToRefresh;

      fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(reqBody),
      })
        .then((response) => {
          return response.json();
        })
        .then((responseJSON) => {
          this.cartJSON = responseJSON;
          this.cartUpdated();
          this.renderSections();
        });
    }
  }

  refreshLayout() {
    fetch(
      window.Shopify.routes.root + "cart?sections=" + this.sectionsToRefresh,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((responseJSON) => {
        this.cartJSON.sections = responseJSON;
        this.cartUpdated();
        this.renderSections();
      });
  }

  openCartDrawer() {
    if (document.querySelector("cart-page")) {
    } else {
      this.cartDrawer =
        this.cartDrawer || document.querySelector("dra-wer#cartdrawer-drawer");
      this.cartDrawer.openDrawer();
    }
  }

  updateCartPage() {
    if (document.querySelector("cart-page")) {
      document.querySelector("cart-page").refreshLayout();
    }
  }

  onItemAdd() {
    this.cartUpdated();
    this.renderSections();
    this.openCartDrawer();
    this.updateCartPage();
  }

  addItem(id, qty) {
    if (id && qty) {
      var reqBody = {};
      reqBody.id = id;
      reqBody.quantity = qty;
      reqBody.sections = this.sectionsToRefresh;

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(reqBody),
      })
        .then((response) => {
          return response.json();
        })
        .then((responseJSON) => {
          this.cartJSON = responseJSON;
          this.onItemAdd();
        });
    }
  }

  addItemFromForm(form) {
    var formData = new FormData(form);
    formData.set("sections", this.sectionsToRefresh);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      "Content-Type": "multipart/form-data",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((responseJSON) => {
        if (responseJSON.status == "422") {
          return;
        }
        this.cartJSON = responseJSON;
        this.onItemAdd();
      });
  }

  registerFormSubmit() {
    this.productForm = document.querySelector("product-form");

    if (this.productForm) {
      this.form = this.productForm.querySelector("form");

      this.productForm.addEventListener("form:atc", () => {
        this.addItemFromForm(this.form);
      });
    }
  }

  connectedCallback() {
    this.registerFormSubmit();
  }
}

class CartPage extends Cart {
  constructor() {
    super();
  }
}

customElements.define("cart-count", CartCount);
customElements.define("cart-drawer", Cart);
customElements.define("cart-page", CartPage);
customElements.define("cartline-rmv", CartItemRemove);
customElements.define("cartline-qty", CartItemQty);

var WDN_CART = document.querySelector("cart-drawer");

class AddToCartSimple extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.submit = this.querySelector('form button[name="submit"]');
    this.submit.addEventListener("click", (e) => {
      e.preventDefault();

      this.form = this.querySelector("form");

      WDN_CART.addItemFromForm(this.form);

      this.submit.setAttribute("disabled", "");

      setTimeout(() => {
        this.submit.removeAttribute("disabled");
      }, 2000);
    });
  }
}

customElements.define("atc-simple", AddToCartSimple);

class CartGift extends HTMLElement {
  constructor() {
    super();
    this.giftRequestData = {};
    this.giftRequestData.items = [];

    this.giftItem = {};
    this.giftItem.id = this.querySelector(
      'input[name="gift-variant-id"]'
    ).value;
    this.giftItem.quantity = 0; // updated later, 0 is the safest as it removes something
    this.giftItem.properties = {};
    this.giftItem.properties._cart_gift = "yes";

    this.action == "nothing";

    if (this.querySelector('input[name="gift-action"]')) {
      this.action = this.querySelector('input[name="gift-action"]').value;
    }
  }

  clearGiftRequestData() {
    this.giftRequestData = {};
  }

  addGift() {
    this.giftItem.quantity = 1;
    this.giftRequestData.items.unshift(this.giftItem);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(this.giftRequestData),
    }).then((response) => {
      this.onGiftChange();
      WDN_CART.refreshLayout();
    });
  }

  removeGift() {
    this.giftItem.quantity = 0;
    this.giftItem.id = this.querySelector('input[name="gift-line-key"]').value;

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(this.giftItem),
    }).then((response) => {
      this.onGiftChange();
      WDN_CART.refreshLayout();
    });
  }

  onGiftChange() {
    this.clearGiftRequestData();
  }

  validateCartForGifts() {
    if (this.attemptCount == 1) {
      return;
    }

    this.attemptCount = 1;

    if (this.action == "remove") {
      this.removeGift();
    }

    if (this.action == "add") {
      this.addGift();
    }

    if (this.action == "nothing") {
    }
  }

  connectedCallback() {
    this.validateCartForGifts();
  }
}

customElements.define("cart-gift", CartGift);

class CartUSP extends HTMLElement {
  constructor() {
    super();
    this.activeTrigger = null;
  }

  init() {
    this.triggers = this.querySelectorAll(".cart-usp-trigger");
    this.content = this.querySelector(".cart-usp-body");
  }

  bind() {
    if (!this.triggers || this.triggers.length === 0) return;

    this.triggers.forEach((trigger, index) => {
      trigger.addEventListener("click", () => {
        if (this.activeTrigger) {
          this.activeTrigger.classList.remove("active-trigger");
        }

        if (this.activeTrigger === trigger) {
          this.content.setAttribute("data-cart-usp-content", "");
          this.activeTrigger = null;
          return;
        }

        trigger.classList.add("active-trigger");

        this.content.setAttribute("data-cart-usp-content", index + 1);
        this.activeTrigger = trigger;
      });
    });
  }

  connectedCallback() {
    this.init();
    this.bind();
  }
}

customElements.define("cart-usp", CartUSP);
